import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import AlertDetailsPage, { getDefaultPageData } from "components/pages/AlertDetailsPage";
import Classes from "model";
import { useEffect } from "react";

export default function CaptureNotifiLimAlertSelected(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;

    let data = getDefaultPageData("26");        
    const details = data.notificationDetails.map(info => {
        info.isEnabled = "false";
        info.contactInfoEnabledIDs = ["0", "1"];

        return info;
    }, []);

    data = BCMSStateManagerCRUD.init(data)
    .update([ "notificationDetails" ], details)
    .submit();

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <AlertDetailsPage data={ data } />
}